import AlertWrapper from './AlertWrapper';

export default AlertWrapper;
